import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  IconButton,
  List,
  ListItem,
  Skeleton,
  Typography,
  Chip,
  Divider,
  useTheme,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ButtonAcaoGrande, Titulo } from "../";
import useAlert from "../../hooks/useAlert";
import { formatMoneyInString } from "../../util/helpers";
import TiposItemCarrinho from "../../util/typesTipoItemCarrinho";
import useStyle from "./style";

import { Fragment, useEffect, useState } from "react";
import { useMutation } from "react-query";
import { RemoveItemByOuroIdMoeda } from "../../api/Carrinho/Ouro";
import { RemoveItemByIdMoeda } from "../../api/Carrinho/Turismo";
import { LimpaCarrinho } from "../../api/PedidoComercial";
import barGold from "../../assets/images/bargold.ico";
import { PositionTooltip, TooltipInformacao } from "../../components";
import { useAuth } from "../../hooks/AuthContext";
import TiposPedido from "../../util/typesTipoPedido";

const TipoItem = {
  turismo: 1,
  comercial: 2,
  ouro: 3,
};

function ItensCart({ pedido, url, urlVitrine, refetchPedido }) {
  const { showAlertInfo, showAlertError, showAlertSuccess } = useAlert();
  const { user } = useAuth();
  const navigation = useNavigate();
  const classes = useStyle();
  const navigate = useNavigate();
  const theme = useTheme();

  const [loading, setLoading] = useState(false);

  const handleContinueOperaco = (event) => {
    event.preventDefault();
    if (pedido) {
      navigate(url);
      return;
    }
    showAlertInfo("Não consta nenhum pedido");
  };

  const handlerComprarMais = (event) => {
    event.preventDefault();
    navigate(urlVitrine);
  };

  const TituloPagina = () => {
    if (pedido?.itens.length > 0) {
      let resp = verificaTipoItemCarrinho();
      return resp?.texto;
    } else return "";
  };

  const verificaTipoItemCarrinho = () => {
    let obj = {
      tipo: "",
      texto: "",
    };

    if (pedido?.itens?.length > 1) {
      obj.texto = "Operacão de Turismo";
      obj.tipo = TipoItem.turismo;
      return obj;
    }

    switch (pedido.itens[0].idTipoItemCarrinho) {
      case TiposItemCarrinho.RemessaExterior:
        obj.texto = "Envio para o Exterior";
        obj.tipo = TipoItem.comercial;
        break;
      case TiposItemCarrinho.RecebimentoExterior:
        obj.texto = "Recebimento do Exterior";
        obj.tipo = TipoItem.comercial;
        break;
      case TiposItemCarrinho.VendaEspecie:
        obj.texto = "Compra de moeda estrangeira";
        obj.tipo = TipoItem.turismo;
        break;
      case TiposItemCarrinho.VendaCartao:
        obj.texto = "Compra de um novo cartão";
        obj.tipo = TipoItem.turismo;
        break;
      case TiposItemCarrinho.RecargaCartao:
        obj.texto = "Recarga do Cartão";
        obj.tipo = TipoItem.turismo;
        break;
      case TiposItemCarrinho.CompraEspecie:
        obj.texto = "Venda da sua moeda estrangeira";
        obj.tipo = TipoItem.turismo;
        break;
      case TiposItemCarrinho.CompraSaldoCartao:
        obj.texto = "Venda de Saldo do cartão";
        obj.tipo = TipoItem.turismo;
        break;
      case TiposItemCarrinho.VendaOuro:
        obj.texto = "Compra de ouro";
        obj.tipo = TipoItem.ouro;
        break;
      default:
        obj.texto = "";
        break;
    }

    return obj;
  };

  useEffect(() => {
    if (pedido?.itens?.length === 0)
      setTimeout(() => {
        navigation("/CarrinhoVazio", {
          replace: false,
        });
      }, 2000);
  }, [pedido, navigation]);

  const mutationRemoveItemComercial = useMutation(LimpaCarrinho, {
    onSuccess: (data) => {
      setLoading(true);
      if (!!data.errorMessage) throw new Error(data.errorMessage, " - RE490");
      showAlertSuccess("Estamos removendo seu item, por favor aguarde");
    },
    onError: async (err, variables, context) => {
      console.error(err);
      showAlertError(
        `Ahh, Algo deu errado, por favor informe ao suporte tecnico o seguinte erro - ${err} - RUQLT `
      );
    },
    onSettled: async () => {
      refetchPedido();
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    },
  });

  const mutationRemoveItemTurismo = useMutation(RemoveItemByIdMoeda, {
    onSuccess: (data) => {
      setLoading(true);
      if (!!data.errorMessage) throw new Error(data.errorMessage, " - RE490");
      showAlertSuccess("Estamos removendo seu item, por favor aguarde");
    },
    onError: async (err, variables, context) => {
      console.error(err);
      showAlertError(
        `Ahh, Algo deu errado, por favor informe ao suporte tecnico o seguinte erro - ${err} - RVPOW `
      );
    },
    onSettled: async () => {
      refetchPedido();
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    },
  });

  const mutationRemoveItemOuro = useMutation(RemoveItemByOuroIdMoeda, {
    onSuccess: (data) => {
      setLoading(true);
      if (!!data.errorMessage) throw new Error(data.errorMessage, " - RE490");
      showAlertSuccess("Estamos removendo seu item, por favor aguarde");
    },
    onError: async (err, variables, context) => {
      console.error(err);
      showAlertError(
        `Ahh, Algo deu errado, por favor informe ao suporte tecnico o seguinte erro - ${err} - RTM1F `
      );
    },
    onSettled: async () => {
      refetchPedido();
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    },
  });

  const handlerRemoveItemComercial = () => {
    mutationRemoveItemComercial.mutate(user.id);
  };

  const handlerRemoveItemTurismo = (idMoeda) => {
    mutationRemoveItemTurismo.mutate({
      idCliente: user.id,
      idMoeda: idMoeda,
    });
  };

  const handlerRemoveItemOuro = (idMoeda) => {
    mutationRemoveItemOuro.mutate({
      idCliente: user.id,
      idMoeda: idMoeda,
    });
  };

  const handlerManipulacaoEventos = (pedido) => (event) => {
    switch (pedido.idTipoOperacaoCarrinho) {
      case TiposPedido.CompraEspecie:
        return handlerRemoveItemTurismo(pedido.moeda.id);
      case TiposPedido.VendaEspecie:
        return handlerRemoveItemTurismo(pedido.moeda.id);
      case TiposPedido.Remessa:
        return handlerRemoveItemComercial();
      case TiposPedido.Recebimento:
        return handlerRemoveItemComercial();
      case TiposPedido.VendaOuro:
        return handlerRemoveItemOuro(pedido.moeda.id);
      default:
        showAlertError(
          "Ops, não foi encontrado o item que deseja remover - RO9PL"
        );
        console.error("o Tipo de pedido esta errado");
        break;
    }
  };

  return (
    <Box sx={{ p: { xs: 2, md: 3 } }}>
      <Card 
        sx={{ 
          borderRadius: 3,
          boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
          overflow: "hidden"
        }}
      >
        <CardContent sx={{ p: { xs: 2, md: 3 } }}>
          {loading ? (
            <>
              <Skeleton width={"100%"} height={50} animation="wave" sx={{ mb: 2 }} />
            </>
          ) : (
            <>
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 3 }}>
                <Box>
                  <Typography variant="h4" fontWeight="700" gutterBottom>
                    Seu Carrinho
                  </Typography>
                  <Typography variant="h6" color="primary" fontWeight="600">
                    {TituloPagina()}
                  </Typography>
                </Box>
                
                {pedido?.itens[0]?.idTipoItemCarrinho !==
                  TiposItemCarrinho.RemessaExterior &&
                  pedido?.itens[0]?.idTipoItemCarrinho !==
                  TiposItemCarrinho.RecebimentoExterior && (
                    <Button
                      variant="outlined"
                      startIcon={<AddShoppingCartIcon />}
                      onClick={handlerComprarMais}
                      sx={{ 
                        borderRadius: 2,
                        textTransform: "none",
                        fontWeight: 600
                      }}
                    >
                      Adicionar mais itens
                    </Button>
                  )}
              </Box>

              {/* Progress Steps */}
              <Box sx={{ display: "flex", alignItems: "center", mb: 4, p: 2, backgroundColor: theme.palette.grey[50], borderRadius: 2 }}>
                <Box sx={{ display: "flex", alignItems: "center", flex: 1 }}>
                  <Chip
                    label="1"
                    color="primary"
                    sx={{ mr: 2, fontWeight: 600 }}
                  />
                  <Typography variant="body1" fontWeight="600">
                    Carrinho
                  </Typography>
                </Box>
                
                <ArrowForwardIosIcon sx={{ color: theme.palette.text.secondary, mx: 2 }} />
                
                <Box sx={{ display: "flex", alignItems: "center", flex: 1, opacity: 0.5 }}>
                  <Chip
                    label="2"
                    variant="outlined"
                    sx={{ mr: 2, fontWeight: 600 }}
                  />
                  <Typography variant="body1">
                    Concluir compra
                  </Typography>
                </Box>
              </Box>
            </>
          )}

          {loading ? (
            <>
              {Array.from({ length: 2 }, (_, index) => (
                <Skeleton
                  key={index}
                  width={"100%"}
                  height={80}
                  animation="wave"
                  sx={{ mb: 2, borderRadius: 2 }}
                />
              ))}
            </>
          ) : (
            <>
              <Card variant="outlined" sx={{ borderRadius: 2, mb: 3 }}>
                <Box sx={{ p: 2 }}>
                  <Grid container sx={{ display: { xs: 'none', md: 'flex' }, mb: 2, px: 2 }}>
                    <Grid item md={4}>
                      <Typography variant="subtitle2" fontWeight="600" color="text.secondary">
                        PRODUTO
                      </Typography>
                    </Grid>
                    <Grid item md={2}>
                      <Typography variant="subtitle2" fontWeight="600" color="text.secondary">
                        QUANTIDADE
                      </Typography>
                    </Grid>
                    <Grid item md={2}>
                      <Typography variant="subtitle2" fontWeight="600" color="text.secondary">
                        TAXA
                      </Typography>
                    </Grid>
                    <Grid item md={2}>
                      <Typography variant="subtitle2" fontWeight="600" color="text.secondary">
                        VALOR
                      </Typography>
                    </Grid>
                    <Grid item md={2}></Grid>
                  </Grid>
                  
                  <Divider sx={{ mb: 2 }} />
                  
                  {pedido?.itens.length > 0 &&
                    pedido.itens.map((p, i) => (
                      <Fragment key={i}>
                        <Grid container sx={{ alignItems: "center", py: 2, px: 2 }}>
                          <Grid item xs={12} md={4}>
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                              {p?.idTipoItemCarrinho === TiposItemCarrinho.VendaOuro ? (
                                <Box
                                  component="img"
                                  src={barGold}
                                  sx={{ width: 40, height: 40, mr: 2, borderRadius: 1 }}
                                  alt="icone moeda ouro"
                                />
                              ) : (
                                <Box
                                  component="img"
                                  src={`/images/Bandeiras/${p?.moeda?.codigoBacen}.svg`}
                                  sx={{ width: 40, height: 40, mr: 2, borderRadius: 1, boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}
                                  alt="icone moeda especie"
                                />
                              )}
                              <Box>
                                <Typography variant="body1" fontWeight="600">
                                  {p?.moeda?.descricao}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                  {p?.moeda?.codigoBacen}
                                </Typography>
                              </Box>
                            </Box>
                          </Grid>
                          
                          <Grid item xs={4} md={2}>
                            <Typography variant="body1" fontWeight="500">
                              {formatMoneyInString(p?.valorMe, p?.moeda?.simbolo)}
                            </Typography>
                          </Grid>
                          
                          <Grid item xs={4} md={2}>
                            <Typography variant="body1">
                              {formatMoneyInString(p.valorTaxaAplicada)}
                            </Typography>
                          </Grid>
                          
                          <Grid item xs={4} md={2}>
                            <Typography variant="body1" fontWeight="600" color="primary">
                              {formatMoneyInString(p.valorTotalMN)}
                            </Typography>
                          </Grid>
                          
                          <Grid item xs={12} md={2} sx={{ textAlign: { xs: 'left', md: 'right' }, mt: { xs: 2, md: 0 } }}>
                            <TooltipInformacao
                              positionStart={PositionTooltip.top}
                              descricao="Excluir item do carrinho"
                            >
                              <IconButton
                                onClick={handlerManipulacaoEventos(p)}
                                sx={{ 
                                  color: theme.palette.error.main,
                                  '&:hover': { backgroundColor: `${theme.palette.error.main}10` }
                                }}
                              >
                                <DeleteOutlineIcon />
                              </IconButton>
                            </TooltipInformacao>
                          </Grid>
                        </Grid>
                        {i < pedido.itens.length - 1 && <Divider />}
                      </Fragment>
                    ))}
                </Box>
              </Card>
            </>
          )}

          {/* Total Section */}
          <Card 
            variant="outlined" 
            sx={{ 
              borderRadius: 2,
              backgroundColor: theme.palette.grey[50],
              borderColor: theme.palette.divider
            }}
          >
            <Box sx={{ p: 3, textAlign: "right" }}>
              <Box sx={{ display: "inline-flex", alignItems: "center", backgroundColor: "white", p: 2, borderRadius: 2, boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }}>
                <Typography variant="h6" fontWeight="600" sx={{ mr: 2 }}>
                  Valor Total:
                </Typography>
                <Typography variant="h5" fontWeight="700" color="primary">
                  {formatMoneyInString(pedido?.valorTotalMoedaNacional ?? 0)}
                </Typography>
              </Box>
            </Box>
          </Card>

          {/* Continue Button */}
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
            <ButtonAcaoGrande 
              Handle={handleContinueOperaco} 
              loading={loading}
              sx={{ 
                minWidth: 200,
                borderRadius: 2,
                py: 1.5,
                fontSize: "1rem",
                fontWeight: 600
              }}
            >
              Continuar Pedido
            </ButtonAcaoGrande>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}

export default ItensCart;